// @flow
import cn from 'classnames';
import React from 'react';
import ContentEditable from 'react-contenteditable';

import type { CustomButtonStyles } from '../../CallToAction';
import type { CustomButtonComponent } from '@site-builder/common/src/flow-types/components';
import type { FiveSymbolLocale } from '@site-builder/common/src/utils/locale';

const LINK_BUTTON_TYPE = 'link';

type Props = {|
  button: CustomButtonComponent,
  locale: FiveSymbolLocale,
  blockType: string,
  isServerSideRender: boolean,
  onChangeText: (e: Event) => void,
  onBlur: () => void,
  onClick: () => void,
  theme: CustomButtonStyles
|};

const LinkButton = ({
  button,
  isServerSideRender,
  locale,
  onChangeText,
  onBlur,
  theme,
  onClick,
  blockType
}: Props) => {
  const { value, label } = button;
  const { link, openNewTab } = value[LINK_BUTTON_TYPE];

  return (
    isServerSideRender ? (
      <a
        className='ui-site-calltoaction ui-site-calltoaction--link'
        // TODO move to css-vars theme
        style={theme}
        href={link || 'javascript:void(0)'} // eslint-disable-line
        target={openNewTab ? '_blank' : '_self'}
        data-button-type='link'
        data-xa-method='elementClick'
        data-xa-name='link_button'
        data-xa-extra={JSON.stringify({
          link,
          block: blockType
        })} rel="noreferrer"
      >
        <div className={cn('ui-site-calltoaction__text')}>
          {label[locale]}
        </div>
      </a>
    ) : (
      <button
        className='ui-site-calltoaction ui-site-calltoaction--link swiper-no-swiping'
        style={theme}
        onClick={onClick}
      >
        <div className='ui-site-calltoaction__text'>
          <ContentEditable
            className='ui-site-calltoaction__text-editor'
            html={label[locale]}
            onChange={onChangeText}
            onBlur={onBlur}
          />
        </div>
      </button>
    )
  );
};

export default LinkButton;
